import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

interface UpdateCategoryData {
  id: string;
  name?: string;
  description?: string;
}

export const useUpdateReservationCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, name, description }: UpdateCategoryData) => {
      // Get the current user and verify permissions
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        throw new Error("Usuario no autenticado");
      }

      // Prepare update data (only include fields that are provided)
      const updateData: { name?: string; description?: string; updated_at: string } = {
        updated_at: new Date().toISOString()
      };
      
      if (name !== undefined) updateData.name = name;
      if (description !== undefined) updateData.description = description;

      console.log('[useUpdateReservationCategory] Updating category:', { id, updateData });

      const { data, error } = await supabase
        .from('reservation_categories')
        .update(updateData)
        .eq('id', id)
        .select('*')
        .single();

      if (error) {
        console.error('[useUpdateReservationCategory] Error:', error);
        throw error;
      }

      console.log('[useUpdateReservationCategory] Category updated successfully:', data);
      return data;
    },
    onSuccess: (category) => {
      console.log('[useUpdateReservationCategory] Cache invalidation for gym:', category.gym_id);
      
      // Invalidate with exact query key that useReservationCategories uses
      queryClient.invalidateQueries({ 
        queryKey: ['reservation-categories', category.gym_id] 
      });
      
      // Also invalidate any queries that might use different gymId patterns
      queryClient.invalidateQueries({ 
        predicate: (query) => {
          return query.queryKey[0] === 'reservation-categories';
        }
      });
      
      toast.success("Categoría actualizada exitosamente");
    },
    onError: (error) => {
      console.error('[useUpdateReservationCategory] Mutation error:', error);
      toast.error("Error al actualizar la categoría: " + error.message);
    },
  });
};